import { Loader } from '@nosinovacao/fe-icons';
import { Button, If, Input, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type AddUserProps } from '../-model/props';

export function AddUserLight({
  name,
  nameErrors,
  nameInputId,
  email,
  emailErrors,
  emailInputId,
  loading,
  disabled,
  onNameChange,
  onEmailChange,
  onSubmit,
}: Readonly<AddUserProps>) {
  const { t } = useI18n();
  return (
    <form
      className="flex size-full flex-col gap-6 max-tablet:pb-8"
      onSubmit={onSubmit}
      data-tid="form-add-user"
    >
      <Input
        label="Services.Users.Add.NameLabel"
        id={nameInputId}
        errors={nameErrors}
        value={name}
        skin="light"
        onChange={(ev) => onNameChange(ev.target.value)}
        data-tid="input-name"
      />
      <Input
        label="Services.Users.Add.EmailLabel"
        id={emailInputId}
        errors={emailErrors}
        value={email}
        skin="light"
        type="email"
        onChange={(ev) => onEmailChange(ev.target.value)}
        data-tid="input-email"
      />
      <Button
        className="mt-auto w-full tablet:w-fit"
        skin="light"
        disabled={disabled || loading}
        data-tid="button-submit-add-user"
      >
        <If condition={loading} otherwise={t('Services.Users.Add.Submit')}>
          <Loader width={24} height={24} />
        </If>
      </Button>
    </form>
  );
}
